const __webpack_error__ = new Error();
module.exports = new Promise((resolve, reject) => {
	if(typeof aggregator !== "undefined") return resolve();
	__webpack_require__.l("https://web.qwep.ru/aggregator-service/remoteEntry.6f27b8f021a6a626fb1f.js", (event) => {
		if(typeof aggregator !== "undefined") return resolve();
		const errorType = event && (event.type === 'load' ? 'missing' : event.type);
		const realSrc = event && event.target && event.target.src;
		__webpack_error__.message = 'Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
		__webpack_error__.name = 'ScriptExternalLoadError';
		__webpack_error__.type = errorType;
		__webpack_error__.request = realSrc;
		__webpack_error__.event = event;
		reject(__webpack_error__);
	}, "aggregator");
}).then(() => (aggregator));